import React from 'react'
import BaseIcon from 'react-icon-base'

const Camera = ({ pathProps = {}, ...props }) => {
  return (
    <BaseIcon viewBox="0 0 22 21" {...props}>
      <g>
        <path
          fill="#FFF"
          fillRule="evenodd"
          d="M18 17h-2v2h2v2h2v-2h2v-2h-2v-2h-2v2zm-6-5.5c0-1.103-.897-2-2-2s-2 .897-2 2 .897 2 2 2 2-.897 2-2zm2 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0zM13 4H7V2h6v2zM1 4V2h2v2h2V0h10v4h5v9h-2V6H2v11h12v2H0V4h1z"
          {...pathProps}
        />
      </g>
    </BaseIcon>
  )
}

export default Camera
